import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import styled from 'styled-components';

import {testIds} from '@dms/routes';

import {FilterPresetButton, FilterPresetButtonProps} from './FilterPresetButton';
import {PresetDragHandle} from './PresetDragHandle';

export function SortableFilterPresetButton(props: FilterPresetButtonProps) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: props.id,
  });
  const transformString = CSS.Transform.toString(transform);

  return (
    <SortableWrapper
      ref={setNodeRef}
      $isDragging={isDragging}
      $transform={transformString}
      $transition={transition}
      {...attributes}
    >
      <PresetDragHandle
        listeners={listeners}
        data-testid={testIds.sourcing.classifieds('filterPresetButtons-drag')}
      />
      <FilterPresetButton {...props} />
    </SortableWrapper>
  );
}

const SortableWrapper = styled.div<{
  $isDragging: boolean;
  $transform: string | undefined;
  $transition: string | undefined;
}>`
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
  transform: ${({$transform}) => $transform};
  transition: ${({$transition}) => $transition};
  opacity: ${({$isDragging}) => ($isDragging ? 0 : 1)};
`;
